import type { SxProps, Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from '@tyro/i18n';
import { BlankFileIcon, VideoIcon } from '@tyro/icons';

interface PageKindIconProps {
  entityType: string | null | undefined;
  withTooltip?: boolean;
  sx?: SxProps<Theme>;
}

export function PageKindIcon({
  entityType,
  withTooltip,
  sx,
}: PageKindIconProps) {
  const { t } = useTranslation(['documentation']);

  const isVideo = entityType === 'video';
  const Icon = isVideo ? VideoIcon : BlankFileIcon;
  const tooltip = isVideo
    ? t('documentation:newPage.entityType.video.label')
    : t('documentation:newPage.entityType.article.label');

  const icon = (
    <Icon
      sx={[
        { fontSize: 18, color: 'text.secondary', flexShrink: 0 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );

  if (!withTooltip) return icon;

  return <Tooltip title={tooltip}>{icon}</Tooltip>;
}
